import { useState, useCallback } from 'react';

export function useGlobalError() {
    const [globalError, setGlobalError] = useState<string | null>(null);

    const triggerError = useCallback((message: string) => {
        setGlobalError(message);
    }, []);

    const clearGlobalError = useCallback(() => {
        setGlobalError(null);
    }, []);

    return {
        globalError,
        triggerError,
        clearGlobalError
    };
}
